import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, Injectable, Pipe, Input, HostBinding, NgModule } from '@angular/core';
import { stripTag, Debounce } from '@js-dot/core';
import { renderIcon } from '@js-dot/ui';
import { DotComponentService, NgClassSwitch } from '@ng-dot/core';
const _c0 = ["*"];
function DotIconComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.innerHTML, i0.ɵɵsanitizeHtml);
  }
}
function DotIconComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function DotIcon24Component_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.innerHTML, i0.ɵɵsanitizeHtml);
  }
}
function DotIcon24Component_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
const _IMAGE = /\.((jpe?|pn|sv)g|gif)$/i;
class DotIconStyleComponent {
  static ɵfac = function DotIconStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIconStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotIconStyleComponent,
    selectors: [["dot-icon-style"]],
    standalone: false,
    decls: 0,
    vars: 0,
    template: function DotIconStyleComponent_Template(rf, ctx) {},
    styles: [".icon24:before{width:24px;font-size:24px}.icon:before{display:inline-block;vertical-align:middle;font-weight:400;text-decoration:none}.icon:before,.icon .icon-image{animation:.24s icon-fade both}.icon-label:empty{display:none}.icon-label:not(first-child){margin-left:.313em}@keyframes icon-fade{0%{opacity:0}}.icon,.icon *:before{vertical-align:middle}.icon-label{font-style:normal}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIconStyleComponent, [{
    type: Component,
    args: [{
      selector: 'dot-icon-style',
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      styles: [".icon24:before{width:24px;font-size:24px}.icon:before{display:inline-block;vertical-align:middle;font-weight:400;text-decoration:none}.icon:before,.icon .icon-image{animation:.24s icon-fade both}.icon-label:empty{display:none}.icon-label:not(first-child){margin-left:.313em}@keyframes icon-fade{0%{opacity:0}}.icon,.icon *:before{vertical-align:middle}.icon-label{font-style:normal}\n"]
    }]
  }], null, null);
})();
class DotIconStyleService {
  constructor() {
    inject(DotComponentService).append(DotIconStyleComponent);
  }
  static ɵfac = function DotIconStyleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIconStyleService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotIconStyleService,
    factory: DotIconStyleService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIconStyleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class DotIconPipe {
  constructor(style) {}
  transform(type, label) {
    return renderIcon(type, label);
  }
  static ɵfac = function DotIconPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIconPipe)(i0.ɵɵdirectiveInject(DotIconStyleService, 16));
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "icon",
    type: DotIconPipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIconPipe, [{
    type: Pipe,
    args: [{
      name: 'icon',
      standalone: false
    }]
  }], () => [{
    type: DotIconStyleService
  }], null);
})();
class DotIconWithNamePipe {
  constructor(style) {}
  transform(object) {
    return typeof object === 'object' ? renderIcon(object?.icon, object?.name) : object;
  }
  static ɵfac = function DotIconWithNamePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIconWithNamePipe)(i0.ɵɵdirectiveInject(DotIconStyleService, 16));
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "iconWithName",
    type: DotIconWithNamePipe,
    pure: true,
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIconWithNamePipe, [{
    type: Pipe,
    args: [{
      name: 'iconWithName',
      standalone: false
    }]
  }], () => [{
    type: DotIconStyleService
  }], null);
})();
class DotIconComponent {
  set fromSelector(type) {
    if (!this._fromSelector || type) {
      this._fromSelector = null;
      this.type = type;
    }
  }
  /**
   * Common Class Name for Icons
   */
  prefix = 'icon';
  typePrefix = '';
  /**
   * Icon Class or Image URL
   */
  type;
  /**
   * Icon Label
   */
  innerHTML;
  _fromSelector = true;
  _node;
  _prefixClass;
  _typeClass;
  _image;
  _init;
  constructor(elementRef, style) {
    const node = elementRef.nativeElement;
    this._node = node;
    this._prefixClass = new NgClassSwitch(node);
    this._typeClass = new NgClassSwitch(node);
    node.className += ' icon';
  }
  get hostTitle() {
    return stripTag(this.innerHTML);
  }
  ngOnInit() {
    this._init = true;
    this._render();
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      if (!changes.hasOwnProperty(key)) {
        continue;
      }
      const change = changes[key];
      const value = change.currentValue;
      this[key] = value;
      if (this._init) {
        this._render();
      }
    }
  }
  _render() {
    const {
      _prefixClass,
      _typeClass
    } = this;
    let {
      prefix,
      type
    } = this;
    const isImage = type && (type.includes('/') || _IMAGE.test(type));
    if (!type || isImage) {
      _prefixClass.pop();
      _typeClass.pop();
      if (!type) {
        return;
      }
    }
    const {
      _node,
      _image
    } = this;
    if (isImage) {
      if (!_image) {
        const image = new Image();
        this._image = image;
        image.loading = 'lazy';
        image.className = 'icon-image';
        _node.insertBefore(image, _node.firstChild);
      }
      this._image.src = type;
    } else {
      if (type.indexOf(':') > -1) {
        [prefix, type] = type.split(':');
      }
      _prefixClass.set(prefix);
      _typeClass.set(prefix + '-' + this.typePrefix + type);
    }
  }
  static ɵfac = function DotIconComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIconComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DotIconStyleService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotIconComponent,
    selectors: [["dot-icon"], ["", "dot-icon", ""]],
    hostVars: 2,
    hostBindings: function DotIconComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵhostProperty("hidden", !ctx.type)("title", ctx.hostTitle);
      }
    },
    inputs: {
      fromSelector: [0, "dot-icon", "fromSelector"],
      prefix: "prefix",
      typePrefix: "typePrefix",
      type: "type",
      innerHTML: "innerHTML"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 1,
    consts: [[1, "icon-label", 3, "innerHTML"], [1, "icon-label"]],
    template: function DotIconComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, DotIconComponent_Conditional_0_Template, 1, 1, "span", 0)(1, DotIconComponent_Conditional_1_Template, 2, 0, "span", 1);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.innerHTML ? 0 : 1);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
__decorate([Debounce(120)], DotIconComponent.prototype, "_render", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIconComponent, [{
    type: Component,
    args: [{
      selector: 'dot-icon, [dot-icon]',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[hidden]': '!type'
      },
      standalone: false,
      template: "@if (innerHTML) {\r\n  <span class=\"icon-label\" [innerHTML]=\"innerHTML\"></span>\r\n} @else {\r\n  <span class=\"icon-label\"><ng-content></ng-content></span>\r\n}\r\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: DotIconStyleService
  }], {
    fromSelector: [{
      type: Input,
      args: ['dot-icon']
    }],
    prefix: [{
      type: Input
    }],
    typePrefix: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    innerHTML: [{
      type: Input
    }],
    hostTitle: [{
      type: HostBinding,
      args: ['title']
    }],
    _render: []
  });
})();
/**
 * @deprecated
 */
class DotIcon24Component extends DotIconComponent {
  prefix = 'icon24';
  set fromSelector(type) {
    super.fromSelector = type;
  }
  constructor(elementRef, style) {
    super(elementRef, style);
  }
  static ɵfac = function DotIcon24Component_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIcon24Component)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(DotIconStyleService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotIcon24Component,
    selectors: [["dot-icon24"], ["i", "dot-icon24", ""]],
    hostVars: 1,
    hostBindings: function DotIcon24Component_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵhostProperty("hidden", !ctx.type);
      }
    },
    inputs: {
      prefix: "prefix",
      fromSelector: [0, "dot-icon24", "fromSelector"]
    },
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 1,
    consts: [[1, "icon-label", 3, "innerHTML"], [1, "icon-label"]],
    template: function DotIcon24Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, DotIcon24Component_Conditional_0_Template, 1, 1, "span", 0)(1, DotIcon24Component_Conditional_1_Template, 2, 0, "span", 1);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.innerHTML ? 0 : 1);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIcon24Component, [{
    type: Component,
    args: [{
      selector: 'dot-icon24, i[dot-icon24]',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[hidden]': '!type'
      },
      standalone: false,
      template: "@if (innerHTML) {\r\n  <span class=\"icon-label\" [innerHTML]=\"innerHTML\"></span>\r\n} @else {\r\n  <span class=\"icon-label\"><ng-content></ng-content></span>\r\n}\r\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: DotIconStyleService
  }], {
    prefix: [{
      type: Input
    }],
    fromSelector: [{
      type: Input,
      args: ['dot-icon24']
    }]
  });
})();
class DotIconModule {
  static ɵfac = function DotIconModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotIconModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotIconModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotIconModule, [{
    type: NgModule,
    args: [{
      declarations: [DotIcon24Component, DotIconComponent, DotIconStyleComponent, DotIconPipe, DotIconWithNamePipe],
      imports: [CommonModule],
      exports: [DotIcon24Component, DotIconComponent, DotIconStyleComponent, DotIconPipe, DotIconWithNamePipe]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotIcon24Component, DotIconComponent, DotIconModule, DotIconPipe, DotIconStyleComponent, DotIconStyleService, DotIconWithNamePipe };
